import { Component, Inject, Renderer2 } from '@angular/core';
import * as AOS from 'aos';
import { Title, Meta } from '@angular/platform-browser';

import { Constants } from '../../common/constants';
import { DOCUMENT } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';


@Component({
  selector: 'app-manufacturing-technology-efficiency-industry4-0-blog',
  templateUrl: './manufacturing-technology-efficiency-industry4-0-blog.component.html',
  styleUrls: ['./manufacturing-technology-efficiency-industry4-0-blog.component.css']
})
export class ManufacturingTechnologyEfficiencyIndustry40BlogComponent {
  baseUrl=Constants.baseUrl;
  constructor(
    private titleService: Title,private seoService:SeoService,
    private metaService: Meta, private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
  ) {}

  ngOnInit(): void {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
{
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/manufacturing_technology_efficiency_industry4_0/"
  },
  "headline": "How Technology can Amplify business efficiency for manufacturers in Industry 4.0",
  "description": "Amidst stringent deadlines and personal aspirations, learn how can one tap into their maximum potential and enhance productivity in the workplace. Read blog.",
  "image": "https://mitresource.com/assets/images/Infographic-blog-images/Infographic-img.png",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT Resources",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2023-11-15"
}`;
   
    this._renderer2.appendChild(this._document.head, script);
    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();
  }
  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('How Technology can Amplify Business Efficiency for Manufacturers in Industry 4.0');

    this.metaService.addTags([
      { name: 'description', content: 'Traditional maintenance practices often rely on scheduled inspections or reactive fixes when equipment fails.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'How Technology can Amplify Business Efficiency for Manufacturers in Industry 4.0' },
      { property: 'og:url', content: 'https://mitresource.com/manufacturing_technology_efficiency_industry4_0/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/Infographic-blog-images/Infographic-img.png' },
      { property: 'og:description', content: 'Traditional maintenance practices often rely on scheduled inspections or reactive fixes when equipment fails.' },
    ]);
  }
 
}
